class MetaDataAtomic {
  constructor(target, metaData) {
    this.target = target;
    this.metaData = metaData;
  }
}
class MetaDataPropertyAtomic extends MetaDataAtomic {
  constructor(target, metaData, property, parameter) {
    super(target, metaData);
    this.property = property;
    this.parameter = parameter;
  }
  call(...parameter) {
    return this.target[this.property](...parameter);
  }
}
export {
  MetaDataAtomic,
  MetaDataPropertyAtomic
};
//# sourceMappingURL=MetaDataAtomic.js.map
